import React, { useEffect } from 'react';
import { Card } from '@app/components/common/Card/Card';
import { Form, Col, Row, Radio, Typography, Space, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Button } from '@app/components/common/buttons/Button/Button';
import { changePassword } from '@app/api/admin.api';
import { UserModel } from '@app/models/UserModel';
import { useLocation, useNavigate } from 'react-router-dom';
import { notificationController } from '@app/controllers/notificationController';
import { InputPassword } from '@app/components/common/inputs/InputPassword/InputPassword';

export type ChangePassword = {
  password: string;
  confirmPassword: string;
};

interface ChangePasswordState {
  record: UserModel;
  onClose: () => void;
  isVisible: boolean;
}

const initialChangePasswordValues: ChangePassword = {
  password: '',
  confirmPassword: '',
};

const ChangePasswordModal: React.FC<ChangePasswordState> = ({ record, onClose, isVisible }: ChangePasswordState) => {

  const [form] = Form.useForm();
  // const { state } = useLocation();
  // const record = state && (state as ChangePasswordState).record;
  const navigate = useNavigate()

  useEffect(() => {
    if (!record) {
      navigate(-1);
    }
  }, [])

  const onFinish = (values: ChangePassword) => {
    return new Promise(() => {
      changePassword(record.id, values.password)
        .then((res) => {
          console.log('res', res);
          notificationController.success({ message: 'Password changed successfully' });
          form.resetFields()
          onClose && onClose()
        })
        .catch((error) => {
          console.log('error: ', error);
          notificationController.error({ message: error });
        });
    });
  };

  return (
    <Modal
      visible={isVisible}
      onCancel={() => onClose && onClose()}
      footer={null}
    >
      <Space size={'large'} direction={'vertical'}>
        <Typography.Title level={3}>Change Password</Typography.Title>
        {record && <Typography.Title level={5}>for {record.name !== '' ? record.name + ' (' + record.email + ')' : record.email}</Typography.Title>}
        {/* <Card> */}
          <Form
            form={form}
            name={'change-password-form'}
            layout={'vertical'}
            initialValues={initialChangePasswordValues}
            onFinish={onFinish}
            autoComplete={'off'}
          >
            <Row gutter={{ xs: 10, md: 15, xl: 30 }}>
              <Col xs={24}>
                <Form.Item
                  name={'password'}
                  label={'Password'}
                  rules={[{ required: true, message: 'Please input your password' }]}
                >
                  <InputPassword />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  name={'confirmPassword'}
                  label={'Confirm Password'}
                  dependencies={['password']}
                  rules={[
                    { required: true, message: 'Please confirm your password' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Passwords do not match'));
                      },
                    }),
                  ]}
                >
                  <InputPassword />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} style={{marginTop: 24}}>
                <Form.Item wrapperCol={{ offset: 6, span: record ? 18 : 12 }}>
                  <Button type={'ghost'} block htmlType={'submit'}>
                    Confirm
                  </Button>
                </Form.Item>
              </Col>
              <Col xs={24} md={12} style={{marginTop: 24}}>
                <Form.Item wrapperCol={{ span: 18 }}>
                  <Button danger type={'ghost'} block onClick={() => onClose && onClose()}>
                    Cancel
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        {/* </Card> */}
      </Space>
    </Modal>
  );
};

export default ChangePasswordModal;
